import React from "react";
import BlogTwentyFive from "../component/BlogTwentyFive";

function BlogTwentyFiveContainer() {
  return <BlogTwentyFive />;
}
export default BlogTwentyFiveContainer;
